import moment from "moment";
import reduxStore from "../configureEnvStore";
import { setStrStartsIn } from "../reducers/common-reducer";
import { GLOBAL_MEETING_DATA } from "../constants/PublicVariables";

class ScheduleSessionService {
    getDaysHoursMinsByDates = (date_future) => {
        let date_now;
        let seconds;
        let minutes;
        let hours;
        let days;
        let arrResult = [];
        date_now = new Date();
        seconds = Math.floor((date_future - date_now) / 1000);
        minutes = Math.floor(seconds / 60);
        hours = Math.floor(minutes / 60);
        days = Math.floor(hours / 24);
        hours = hours - days * 24;
        minutes = minutes - days * 24 * 60 - hours * 60;
        seconds = seconds - days * 24 * 60 * 60 - hours * 60 * 60 - minutes * 60;
        arrResult["days"] = days;
        arrResult["hours"] = hours;
        arrResult["minutes"] = minutes;
        arrResult["seconds"] = seconds;
        return arrResult;
    };

    convertstrtoUTCDate = (datestr) => {
        const dateformat = "YYYY-MM-DD hh:mm:ss A";
        const utc = moment.utc(datestr, dateformat);
        return utc;
    };

    convertUTCToLocalDate = (momentdate) => {
        return momentdate.local();
    };

    UTCStringToLocalDate = (utcstr) => {
        const utcdate = this.convertstrtoUTCDate(utcstr);
        return this.convertUTCToLocalDate(utcdate);
    };

    showUpcomingEvent = (sessionScheduleTime) => {
        let date1 = sessionScheduleTime.split(" ");
        let date2 = date1[0].split("-");
        let date = date2[2] + "-" + date2[1] + "-" + date2[0] + " " + date1[1] + " " + date1[2];
        let newDate = this.UTCStringToLocalDate(date);
        sessionScheduleTime = this.getDaysHoursMinsByDates(newDate);
        let strStartsIn = "";
        if (
            sessionScheduleTime["days"] == 0 &&
            sessionScheduleTime["hours"] == 0 &&
            sessionScheduleTime["minutes"] == 0 &&
            sessionScheduleTime["seconds"] > 0
        ) {
            GLOBAL_MEETING_DATA.onlySecondsDiff = true; //only seconds
        } else if (sessionScheduleTime["days"] == 0 && sessionScheduleTime["hours"] == 0 && sessionScheduleTime["minutes"] > 0) {
            strStartsIn = sessionScheduleTime["minutes"] + " min.";
        } else if (sessionScheduleTime["days"] == 0 && sessionScheduleTime["minutes"] == 0 && sessionScheduleTime["hours"] > 0) {
            if (sessionScheduleTime["hours"] == 1) {
                strStartsIn = sessionScheduleTime["hours"] + " hr.";
            } else {
                strStartsIn = sessionScheduleTime["hours"] + " hrs.";
            }
        } else if (sessionScheduleTime["hours"] == 0 && sessionScheduleTime["minutes"] == 0 && sessionScheduleTime["days"] > 0) {
            strStartsIn = sessionScheduleTime["days"] + " d."; //only days
        } else {
            //days hours mins available
            if (sessionScheduleTime["days"] > 0) {
                strStartsIn += sessionScheduleTime["days"] + "d";
            }
            if (sessionScheduleTime["hours"] > 0) {
                let hourText = "hr";
                if (sessionScheduleTime["hours"] > 1) {
                    hourText = "hrs";
                }
                if (strStartsIn) {
                    strStartsIn += " " + sessionScheduleTime["hours"] + hourText;
                } else {
                    strStartsIn += sessionScheduleTime["hours"] + hourText;
                }
            }
            if (sessionScheduleTime["minutes"] > 0) {
                if (strStartsIn) {
                    strStartsIn += " " + sessionScheduleTime["minutes"] + "min";
                } else {
                    strStartsIn += sessionScheduleTime["minutes"] + "min";
                }
            }
            strStartsIn += ".";
        }
        reduxStore.dispatch(setStrStartsIn(strStartsIn));
    };
}

export default new ScheduleSessionService();
